let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
export const ACTableRowNoInlineRadius = styledWithTheme.tr(_t || (_t = _`
  th:first-child {
    border-top-left-radius: 0 !important;
  }

  th:last-child {
    border-top-right-radius: 0 !important;
  }
`));